import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=92efa808&"
import script from "./checkbox.vue?vue&type=script&lang=ts&setup=true&"
export * from "./checkbox.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports